export const cdnPath = (path) => {
  // eslint-disable-next-line no-undef
  const tag = process.env.DATE_IMG_TAG
  if (tag) {
    return 'https://cdn.courseticket.com/mf/' + tag + path
  }
  return 'http://localhost:8081' + path
}
export const remoteUrl = (mfName, localPort, svCl) => {
  // eslint-disable-next-line no-undef
  const DATE_IMG_TAG = process.env.DATE_IMG_TAG
  if (DATE_IMG_TAG) {
    const domain = 'https://cdn.courseticket.com/mf/'
    return domain + DATE_IMG_TAG + '/' + mfName + '/' + svCl + '/'
  }
  let localhost
  if (svCl === 'client') {
    localhost = 'localhost'
  } else {
    localhost = 'host.docker.internal'
  }
  return 'http://' + localhost + ':' + localPort + '/' + svCl + '/'
}
export const remote = (mfName, localPort, svCl) => {
  return mfName + '@' + remoteUrl(mfName, localPort, svCl) + 'remoteEntry.js'
}
